(() => {
  if (window.hhDirectoryNavigation) return;
  window.hhDirectoryNavigation = true;
  const updateLinks = () => {
    document.querySelectorAll('[data-directory-jump]').forEach((link) => {
      const destination = document.getElementById(link.hash.slice(1));
      link.hidden = !destination || destination.closest('[hidden]') !== null;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateLinks, { once: true });
  else updateLinks();
  document.addEventListener('shopify:section:load', updateLinks);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(updateLinks));
})();
